
import { useTranslation } from 'react-i18next';

const WhyPartnerSection = () => {
  const { t } = useTranslation('partnership');

  const reasons = [
    { icon: 'ri-store-2-line', title: t('whyPartner.items.1.title'), description: t('whyPartner.items.1.description') },
    { icon: 'ri-bank-card-line', title: t('whyPartner.items.4.title'), description: t('whyPartner.items.4.description') },
    { icon: 'ri-passport-line', title: t('whyPartner.items.5.title'), description: t('whyPartner.items.5.description') },
    { icon: 'ri-timer-line', title: t('whyPartner.items.6.title'), description: t('whyPartner.items.6.description') },
    { icon: 'ri-scales-3-line', title: t('whyPartner.items.3.title'), description: t('whyPartner.items.3.description') },
    { icon: 'ri-line-chart-line', title: t('whyPartner.items.7.title'), description: t('whyPartner.items.7.description') },
  ];

  return (
    <section className="py-8 md:py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <span className="text-gold-400 font-semibold text-[10px] md:text-sm uppercase tracking-wider">{t('whyPartner.badge')}</span>
          <h2 className="text-lg md:text-3xl lg:text-4xl font-bold text-white mt-2 md:mt-3 mb-2 md:mb-4 font-serif leading-snug">
            {t('whyPartner.title')}
          </h2>
          <p className="text-[10px] md:text-base text-gray-400 max-w-2xl mx-auto">
            {t('whyPartner.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-xl p-3 md:p-8 border border-white/10 hover:border-gold-500/30 hover:bg-white/10 transition-all duration-300 group"
            >
              <div className="w-8 h-8 md:w-14 md:h-14 flex items-center justify-center bg-gold-600/20 rounded-lg md:rounded-xl mb-2 md:mb-5 group-hover:bg-gold-600/30 transition-colors">
                <i className={`${reason.icon} text-sm md:text-2xl text-gold-400`}></i>
              </div>
              <h3 className="text-xs md:text-lg font-bold text-white mb-1 md:mb-3">{reason.title}</h3>
              <p className="text-[10px] md:text-sm text-gray-400 leading-relaxed line-clamp-4 md:line-clamp-none">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyPartnerSection;
